export default function getResource(label, vars = []) {
    const resources = {
        store: 'Store',
        edit: 'Edit',
        pickAnArtist: 'Pick An Artist',
        anyAvailableArtist: 'Any available artist',
        artistAvailabilityNotice: 'Artist might change depending on availability that day.',
        continueToReviewAndPay: 'Continue to Review & Pay',
        pickDateAndTime: 'Pick A Date And Time',
        showCalendar: 'Show calendar',
        timeSlotsTooltip: 'Time slots not displayed are fully booked.',
        morning: 'Morning',
        afternoon: 'Afternoon',
        evening: 'Evening',
        noAvailableTimes: 'No available times'
    };

    return resources[label];
}
